/* src/app/rt-components/sidebar/sidebar.component.scss */
:host {
  display: block;
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  transition: left 0.2s ease-in-out, right 0.2s ease-in-out;
  width: 220px;
  will-change: left, right;
  z-index: 997;
}
@media screen and (max-width: 2048px) {
  :host {
    left: -220px;
  }
}
.rtl :host {
  left: auto;
  right: 0;
}
@media screen and (max-width: 2048px) {
  .rtl :host {
    left: auto;
    right: -220px;
  }
}
:host .site-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #FFFFFF;
}
@media screen and (max-width: 2048px) {
  :host .site-sidebar {
    position: relative;
    z-index: 9999;
  }
}
:host .sidebar-overlay {
  background: rgba(60, 78, 98, 0.2);
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: 0.2s opacity 0s ease-in-out, 0s visibility 0.2s ease-in-out;
  visibility: hidden;
  width: 100%;
  z-index: 9998;
}
/*# sourceMappingURL=sidebar.component.css.map */
